import {UserDto} from "../utils/types/user";
import {http} from "./api/restApiClient";

export const AUTH_SIGN_IN_URL = "/auth/sign-in";

export interface IdpInfo {
  organizationId: string;
  idProvider: string;
}

export const AuthService = {
  signIn: (data: {email: string; password: string}) =>
    http.post<{token: string; user: UserDto}>(AUTH_SIGN_IN_URL, data),
  getIdpListByDomain: (email: string) =>
    http.post<IdpInfo>("/sso/idp-name", {email}),
  getSamlRedirect: (organizationId: string, idProvider: string) => {
    return http.get<{url: string}>(
      `/sso/login/${organizationId}/${idProvider}`,
    );
  },
};
